module.exports = __webpack_public_path__ + "static/media/caramida-aparenta-klinker-Lithium.4760f5e0.jpg";